import { FC } from 'react';
import { Box, Button, Checkbox, Container, List, ListItem, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { CheckBox, CheckBoxOutlineBlank, CheckCircle, CircleOutlined } from '@mui/icons-material';
import { usePreferencesController } from './usePreferencesController';
import { green } from '@mui/material/colors';
import { useNavigate } from 'react-router-dom';
import { NotificationType } from '@viewCreators/CommunicationPreferencesViewCreator';

const ListItemBox = styled(ListItem)({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  paddingLeft: 16,
  margin: 4,
  borderRadius: 4,
  backgroundColor: '#fff',
  flexGrow: 1,
});

const CustomCheckbox = styled(Checkbox, {
  shouldForwardProp: (prop) => prop !== 'recommended',
})<{ recommended?: boolean }>(({ recommended }) => ({
  borderRadius: 0,
  padding: 4,
  height: 13,
  width: 13,
  '::after': {
    content: recommended ? '"*"' : '""', // Adds the asterisk
    position: 'absolute', // Positions the asterisk absolutely within the checkbox
    top: '-5px', // Adjust this value to move it to the upper-right corner
    right: '-10px', // Adjust this value to move it to the upper-right corner
    fontSize: '12px', // Adjust the font size as needed
  },
}));

const Preferences: FC = () => {
  const { preferences, handleNotificationChanged, handleSave, handleCancel } = usePreferencesController();
  const navigate = useNavigate();

  const handleEditPhone = () => {
    navigate('/preferences/edit-phone');
  };

  return (
    <Container sx={{ pt: 2, pb: 2, height: '100%', width: '100%' }}>
      <h1>Communication Preferences</h1>
      {/*<Typography variant={'subtitle2'} color={'textPrimary'}>*/}
      {/*  Mobile*/}
      {/*</Typography>*/}
      {/*<ListItemBox>*/}
      {/*  <Typography variant={'body1'}>+1 (303) 550-4054</Typography>*/}
      {/*  <IconButton color={'primary'} onClick={handleEditPhone}>*/}
      {/*    <ModeEdit></ModeEdit>*/}
      {/*  </IconButton>*/}
      {/*</ListItemBox>*/}
      <ListItemBox
        sx={{
          backgroundColor: 'transparent',
          paddingTop: 2,
          paddingRight: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          marginTop: 2,
          marginRight: 0,
          marginBottom: 2,
          marginLeft: 0,
        }}
      >
        <Typography variant={'subtitle2'} color={'textPrimary'} sx={{ fontWeight: 600, fontSize: '16px' }}>
          Notifications
        </Typography>
        <span></span>
        <Box sx={{ justifyContent: 'end', display: 'flex', gap: 1 }}>
          <Typography variant={'caption'} sx={{ textTransform: 'capitalize' }}>
            Push Notification
          </Typography>
          <Typography variant={'caption'} sx={{ textTransform: 'capitalize' }}>
            Email
          </Typography>
          <Typography variant={'caption'} sx={{ textTransform: 'capitalize' }}>
            SMS Text
          </Typography>
        </Box>
      </ListItemBox>
      <List sx={{ backgroundColor: '#fff', borderRadius: '6px', padding: '0' }}>
        {preferences.map((preference) => {
          return (
            <ListItemBox
              key={preference.id}
              sx={{
                backgroundColor: 'transparent',
                padding: '15px 16px',
                margin: '0',
                borderBottom: preferences[preferences.length - 1].id === preference.id ? 'none' : '1px solid #f2f2f2',
              }}
            >
              <Typography variant={'subtitle2'} sx={{ textTransform: 'capitalize', marginRight: 2, fontSize: '15px' }}>
                {preference.text}
              </Typography>
              <span></span>
              <Box sx={{ justifyContent: 'end', gap: 5, display: 'flex' }}>
                <CustomCheckbox
                  onChange={(e) =>
                    handleNotificationChanged(e, {
                      preferenceId: preference.id,
                      notificationType: NotificationType.PUSH,
                    })
                  }
                  checked={preference.checked.push}
                  recommended={preference.recommended === 0}
                  icon={<CheckBoxOutlineBlank color="disabled" />}
                  checkedIcon={<CheckBox sx={{ color: green['700'] }} />}
                />
                <CustomCheckbox
                  onChange={(e) =>
                    handleNotificationChanged(e, {
                      preferenceId: preference.id,
                      notificationType: NotificationType.EMAIL,
                    })
                  }
                  checked={preference.checked.email}
                  recommended={preference.recommended === 1}
                  icon={<CheckBoxOutlineBlank color={'disabled'} />}
                  checkedIcon={<CheckBox sx={{ color: green['700'] }} />}
                ></CustomCheckbox>
                <CustomCheckbox
                  onChange={(e) =>
                    handleNotificationChanged(e, {
                      preferenceId: preference.id,
                      notificationType: NotificationType.SMS,
                    })
                  }
                  checked={preference.checked.SMS}
                  recommended={preference.recommended === 2}
                  icon={<CheckBoxOutlineBlank color={'disabled'} />}
                  checkedIcon={<CheckBox sx={{ color: green['700'] }} />}
                ></CustomCheckbox>
              </Box>
            </ListItemBox>
          );
        })}
      </List>
      <Box display={'flex'} gap={1} flexDirection={'row'} justifyContent={'space-between'} padding={'8px 0 8px 8px'}>
        <Typography variant={'caption'}>* Recommended</Typography>

        <Box display={'flex'} gap={1}>
          <Button variant={'text'} onClick={handleCancel}>
            Cancel
          </Button>
          <Button variant={'contained'} onClick={handleSave}>
            Save Changes
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default Preferences;
